import { render, staticRenderFns } from "./Tracking-links.vue?vue&type=template&id=230ba1f4"
import script from "./Tracking-links.vue?vue&type=script&lang=js"
export * from "./Tracking-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports